const defaultState = () => ({
  reFetchCalendarView: false,
  jumpToTodayoToday: false,
  event: {},
  grid: {
    lastScrollPosition: null
  }
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_REFETCH_CALENDAR_VIEW (state, reFetch) {
    state.reFetchCalendarView = reFetch
  },
  SET_JUMP_TO_TODAY (state, val) {
    state.jumpToTodayoToday = val
  },
  SET_EVENT (state, event) {
    state.event = event
  },
  SET_GRID_LAST_SCROLL_POSITION (state, scrollPosition) {
    state.grid.lastScrollPosition = scrollPosition
  }
}

export const getters = {
  REFETCH_CALENDAR_VIEW (state) {
    return state.reFetchCalendarView
  },
  JUMP_TO_TODAY (state) {
    return state.jumpToTodayoToday
  },
  GET_EVENT (state) {
    return state.event
  },
  GET_GRID_LAST_SCROLL_POSITION (state) {
    return state.grid.lastScrollPosition
  }
}

export const actions = {
}
